import { Component } from '@angular/core';
import {
  REFERENCE_DATA_BUCKET_LABELS,
  REFERENCE_DATA_NAVIGATOR,
  REFERENCE_DATA_NOTIFIER,
  REFERENCE_DATA_PERMISSIONS,
  REFERENCE_DATA_REPORT_FILENAME,
  REFERENCE_DATA_SERVICE
} from '@nucleus/reference-data-ui';
import {
  TasksenseReferenceDataNavigatorAdapter,
  TasksenseReferenceDataNotifierAdapter,
  TasksenseReferenceDataPermissionsAdapter,
  TasksenseReferenceDataServiceAdapter
} from './reference-data.adapter';

/**
 * ADMIN-ONLY global bucket browser host. Thin shell over
 * @nucleus/reference-data-ui's <lib-reference-data-buckets> (the master
 * "list every bucket" screen). Registers the four tenant adapters via DI
 * providers — same wiring as ReferenceDataComponent but adds the NAVIGATOR
 * so clicking a bucket drills into .../reference-data/<bucket>. The screen
 * is gated on reference-data:manage inside the lib (canManage).
 */
@Component({
  selector: 'reference-data-buckets',
  templateUrl: './reference-data-buckets.component.html',
  styleUrl: './reference-data.component.css',
  standalone: false,
  providers: [
    { provide: REFERENCE_DATA_SERVICE,         useExisting: TasksenseReferenceDataServiceAdapter },
    { provide: REFERENCE_DATA_PERMISSIONS,     useExisting: TasksenseReferenceDataPermissionsAdapter },
    { provide: REFERENCE_DATA_NOTIFIER,        useClass:    TasksenseReferenceDataNotifierAdapter },
    { provide: REFERENCE_DATA_NAVIGATOR,       useExisting: TasksenseReferenceDataNavigatorAdapter },
    { provide: REFERENCE_DATA_REPORT_FILENAME, useValue:    'tasksense' },
    { provide: REFERENCE_DATA_BUCKET_LABELS,   useValue:    { AddressType: 'Address Type' } },
  ]
})
export class ReferenceDataBucketsComponent { }
